import useApproval from 'src/common/contracts/hooks/token/useApproval'
import useApproveToken from 'src/common/contracts/hooks/token/useApproveToken'
import { AnyToken } from 'src/common/types/models/Tokens'
import { big, ZERO } from 'src/common/utils/big-utils'
import { BigSource } from 'big.js'
import { isNil } from 'lodash'

type UseApprovalStatusParams = {
  owner: string | undefined
  spender: string | undefined
  token: AnyToken | undefined
  amountToSpend: BigSource | undefined
}

const useApprovalStatus = ({
  owner = '',
  spender = '',
  token,
  amountToSpend = ZERO,
}: UseApprovalStatusParams) => {
  const approveToken = useApproveToken()
  const {
    allowance,
    refetch: refetchAllowance,
    isLoading: allowanceLoading,
  } = useApproval({
    token,
    owner,
    spender,
  })

  const needsApproval = allowance?.lt(
    big(amountToSpend).toFixed(token?.decimals)
  )

  const approveTokenTx = needsApproval
    ? approveToken({
        tokenAddress: token?.contractAddress,
        tokenType: token?.type,
        spender,
        amount: amountToSpend,
      })
    : undefined


  return {
    approveTokenTx,
    needsApproval,
    refetchAllowance,
    loading: allowanceLoading || isNil(allowance),
  }
}

export default useApprovalStatus
